// extracted by mini-css-extract-plugin
module.exports = {"inputValue":"MultipleTextRefinement_inputValue__LAFUX","clearIcon":"MultipleTextRefinement_clearIcon__mohO0"};